import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { LoaderComponent } from './components/loader/loader.component';
import { HasRightDirective } from './directives/has-right.directive';

@NgModule({
  declarations: [HeaderComponent, LoaderComponent, HasRightDirective, FooterComponent],
  imports: [CommonModule, NgbDropdownModule, NgbTooltipModule, RouterModule],
  exports: [HeaderComponent, LoaderComponent, HasRightDirective, FooterComponent],
})
export class NioCommonModule {}
